import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "./Testimonial.css";
import { FaStar } from "react-icons/fa";

const MAX_LENGTH = 200;

const Testimonial = () => {
  const data = [
    {
      id: 1,
      img: require("../../Assets/img20.png"),
      name: "Dr.Anish Reddy",
      description:
        "As a healthcare provider, I truly value how Wihan bridges the gap between patients and care teams. The platform simplifies follow-ups, reduces communication delays, and gives me real-time access to patient information. This not only improves treatment outcomes but also helps me focus more on care than on administrative tasks. Wihan has become an essential partner in delivering patient-centered healthcare.",
    },
    {
      id: 2,
      img: require("../../Assets/img21.png"),
      name: "Priya Sharma",
      description:
        "Wihan has made my nursing role much more effective. Instead of spending hours on phone calls or paperwork, I can now monitor patient recovery directly through the platform. It alerts me if a patient skips medication or reports discomfort, so I can guide them immediately. This saves time, prevents complications, and makes patients feel supported 24/7. For nurses like me, Wihan is not just a tool—it’s an extra pair of hands in patient care.",
    },
    {
      id: 3,
      img: require("../../Assets/img20.png"),
      name: "Aniketh",
      description:
        "As a caregiver, Wihan has been a big support for me. Managing medicines, follow-ups, and daily health updates used to be stressful, but now everything is organized in one place. I get timely reminders, and can share updates with doctors easily. Wihan makes caregiving less stressful and more reassuring. ",
    },
  ];

  const [slidesToShow, setSlidesToShow] = useState(2);

  const updateSlidesToShow = () => {
    if (window.innerWidth <= 768) {
      setSlidesToShow(1);
    } else if (window.innerWidth <= 1024) {
      setSlidesToShow(2);
    } else {
      setSlidesToShow(2);
    }
  };

  useEffect(() => {
    updateSlidesToShow();
    window.addEventListener("resize", updateSlidesToShow);
    return () => window.removeEventListener("resize", updateSlidesToShow);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    appendDots: (dots) => <ul className="custom-dots">{dots.slice(0, 3)}</ul>,
    customPaging: () => <div className="custom-dot" />,
    arrows: false,
  };

  return (
    <div className="blog-section">
      <h2 className="heading-h1">What Our CarePreneurs Say</h2>
      <Slider {...settings}>
        {data.map((item) => (
          <TestimonialCard key={item.id} item={item} />
        ))}
      </Slider>
    </div>
  );
};

const TestimonialCard = ({ item }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleReadMore = () => setExpanded(!expanded);

  const truncatedText =
    item.description.length > MAX_LENGTH && !expanded
      ? item.description.slice(0, MAX_LENGTH) + "..."
      : item.description;

  return (
    <div className="blog-card">
      <img src={item.img} alt={item.name} className="blog-img" />
      <div className="stars">
        {[...Array(5)].map((_, index) => (
          <FaStar key={index} className="star-icon" color="#FFD700" />
        ))}
      </div>
      <p className="blog-desc">
        {truncatedText}
        {item.description.length > MAX_LENGTH && (
          <span
            onClick={toggleReadMore}
            className="read-more"
            style={{ color: "#1d808c", cursor: "pointer", fontWeight: "bold" }}
          >
            {expanded ? " Read Less" : " Read More"}
          </span>
        )}
      </p>
      <h3 className="blog-name">{item?.name}</h3>
    </div>
  );
};

export default Testimonial;
